import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from "@angular/core";
import { ToastrService } from "ngx-toastr";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import * as _ from "lodash";
import {
  AddSwitchTransactionLogCommand,
  SwitchTransactionEntryCommand,
  TransactionDashboardService,
} from "../../../web-api-client";
import {
  AbstractControl,
  AbstractControlOptions,
  AsyncValidatorFn,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { formatDate } from "@angular/common";
import { ValidationErrorHandlerService } from "../../../core/services/validation-error-handler.service";
// import { BankPortalDepReqModel } from "src/app/core/models/bankportal.model";
type AOA = any[];
@Component({
  selector: "app-switch-transaction-entry",
  templateUrl: "./switch-transaction-entry.component.html",
  styleUrls: ["./switch-transaction-entry.component.css"],
})
export class SwitchTransactionEntryComponent implements OnInit {
  convertedDate!: string;
  switchTransactionEntryData: SwitchTransactionEntryCommand =
    new SwitchTransactionEntryCommand();
  isShowTable: boolean = false;
  public files: any;
  dateValue: Date = new Date();
  wopts: XLSX.WritingOptions = { bookType: "xlsx", type: "array" };
  fileName: string = "Upload_Format.xlsx";
  file: any;
  items = AddSwitchTransactionLogCommand;
  p = 1;
  fileLength: any;
  dataFromExcel: AddSwitchTransactionLogCommand[] = [];
  data1: AOA = [
    [
      "Merchant Id",
      "Merchant Name",
      "Transaction Type",
      "Response Code",
      "Response Lable",
      "Reference Number",
      "Currency Code",
      "Transaction Amount",
      "Transaction Date",
      "Batch Number",
      "Remarks",
      "Pos Entry Mode",
      "Stan Number",
    ],
  ];
  dsitrictExportName: string = "DistrictList.xlsx";
  public isReqSave: boolean = false;
  @ViewChild("scrollMe", { static: false })
  private myScrollContainer!: ElementRef;
  public requestFilter: any;
  public editIndex!: number;
  public isLoading: boolean = false;
  public submitted: boolean = false;
  public isUpdate: boolean = false;
  public isShowGrid: boolean = false;
  bankBranches: any[] = [];
  referenceNumberErrors: string[] = [];
  public editted: boolean = false;
  @HostListener("scroll", ["$event"])
  todayDate = new Date();

  loadingIndicator!: boolean;
  columnDefs: any[] = [];
  excelArray: any[] = [];
  columns: any[] = [];
  selCategory: any;

  public provinces: String = "province";
  public uploadType: string = "";
  public formResetToggle = true;
  selDistrict!: string | null;
  keyword = "branchName";
  selProvince!: string | null;

  registerForm!: UntypedFormGroup;

  selSettlementSecondaryId!: string | null;
  selSettlementPrimaryId!: string | null;
  selTransactionSecondaryId!: string | null;
  selTransactionPrimaryId!: string | null;
  selMerchantCategoryId!: string | null;
  selCurrency!: string;

  public loading: boolean = false;

  arrayBuffer: any;

  public switchTransactionForm: FormGroup = new FormGroup({
    MERCHANT_ID: new FormControl(""),
    MER_NAME: new FormControl(""),
    TRAN_TYPE: new FormControl(""),
    RESPOSE_CODE: new FormControl(""),
    responseLabel: new FormControl(""),
    referenceNumber: new FormControl(""),
    currencyCode: new FormControl(0),
    transactionAmount: new FormControl(0),
    batchNumber: new FormControl(""),
    transactionDate: new FormControl(""),
    remarks: new FormControl(""),
    posEntryMode: new FormControl(""),
    stanNumber: new FormControl(""),
    cardType: new FormControl(""),
    terminalId: new FormControl(""),
  });
  districtList: any;
  filterdate!: string;
  terminalTypeList: any;
  category: any;
  excelData: any[] = [];
  headers!: string[];
  switchTransaction!: AddSwitchTransactionLogCommand;
  addedRow!: any[];
  dateValues: Date[] | undefined;
  fromDate!: string | number | Date;
  toDate!: string | number | Date;
  pageSize: any;
  currentPage: number | undefined;
  private _regionService: any;
  totalCount: any;
  totalPage: any;
  regionData: never[] | undefined;
  messageService: any;
  itemsPerPage!: number;
  paginatedSwitchTransactionLogArray: any;
  errorMessage: any;

  customGroupValidation:
    | AbstractControlOptions
    | ValidatorFn
    | ValidatorFn[]
    | null
    | undefined;
  namesArray: any;
  referenceNumberValidationData!: { [key: string]: number[] };

  constructor(
    private _toastr: ToastrService,
    private _transactionDashboardService: TransactionDashboardService,
    private _formbuilder: FormBuilder,
    private _validationError: ValidationErrorHandlerService
  ) { }

  ngOnInit(): void {
    this.switchTransactionForm = this._formbuilder.group({
      MERCHANT_ID: ["", Validators.required],
      MER_NAME: ["", Validators.required],
      TRAN_TYPE: ["", Validators.required],
      RESPOSE_CODE: ["", Validators.required],
      responseLabel: [""],
      batchNumber: [""],
      referenceNumber: ["", [Validators.required]],
      currencyCode: [0, Validators.required],
      transactionAmount: [0, Validators.required],
      remarks: [""],
      posEntryMode: ["", Validators.required],
      stanNumber: ["", Validators.required],
      cardType: ["", Validators.required],
      terminalId: ["", Validators.required],
    });

    this.registerForm = this._formbuilder.group({
      switchTransactionLogArray: this._formbuilder.array(
        [],
        this.duplicateValueValidator()
      ),
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.switchTransactionForm.controls;
  }

  get switchTransactionLogArray(): UntypedFormArray {
    return this.registerForm.get(
      "switchTransactionLogArray"
    ) as UntypedFormArray;
  }
  public switchTransactionEntry(): FormGroup {
    return this._formbuilder.group({
      merchantId: ["", Validators.required],
      merchantName: ["", Validators.required],
      terminalId: ["", Validators.required],
      transactionType: ["", Validators.required],
      responseCode: ["", Validators.required],
      responseLabel: [""],
      referenceNumber: ["", Validators.required],
      currencyCode: [0, Validators.required],
      transactionAmount: [0, Validators.required],
      cardType: ["", Validators.required],
      transactionDate: ["", Validators.required],
      batchNumber: [""],
      remarks: [""],
      posEntryMode: ["", Validators.required],
      stanNumber: ["", Validators.required],
    });
  }

  onFileChange(event: any): void {
    const file = event.target.files[0];
    this.parseExcelFile();
    const reader: FileReader = new FileReader();

    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const workbook: XLSX.WorkBook = XLSX.read(bstr, { type: "binary" });
      const worksheetName: string = workbook.SheetNames[0];
      const worksheet: XLSX.WorkSheet = workbook.Sheets[worksheetName];
      const jsonData: any[] = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
      });
      const startDate = formatDate(this.fromDate, "yyyy-MM-dd", "en-US");
      const endDate = formatDate(this.toDate, "yyyy-MM-dd", "en-US");

      // Process the jsonData as needed, e.g., assign it to a variable or display it in a table
      console.log(jsonData);
    };

    reader.readAsBinaryString(file);
  }
  parseExcelFile() {
    const fileReader = new FileReader();
    fileReader.onload = (e: any) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const worksheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[worksheetName];
      const jsonData: any[] = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
      });

      // Extract the date and time values and parse them
      this.dateValues = jsonData
        .map((row) => row[0]) // Assuming the date and time values are in the first column
        .filter((value) => !!value)
        .map((value) => new Date(value));
    };
    fileReader.readAsArrayBuffer(this.file);
  }

  get AddSwitchTransactionLogCommand(): UntypedFormArray {
    return this.registerForm.get(
      "AddSwitchTransactionLogCommand"
    ) as UntypedFormArray;
  }

  selectRequest(value: number) {
    this.switchTransaction = new AddSwitchTransactionLogCommand();
    this.addedRow = new Array<any>();
    this.requestFilter = value;
  }
  updatePaginatedData() {
    const startIndex = (this.p - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.paginatedSwitchTransactionLogArray = (
      this.switchTransactionLogArray.controls as any[]
    ).slice(startIndex, endIndex);
  }

  pageChange() {
    this.updatePaginatedData();
  }

  addFile($event) {
    let fileExtension = $event.target.files[0].name.split(".").pop();
    if (
      fileExtension == "csv" ||
      fileExtension == "xlsx" ||
      fileExtension == "xls"
    ) {
      this.prepareFilesList($event.target.files);
    } else {
      this._toastr.error("File Not Supported", "Error");
    }
  }
  deleteRequest(index) {
    this.switchTransactionLogArray.removeAt(index);
  }
  selectFile(event: { target: { files: any[] } }) {
    this.file = event.target.files[0];
  }
  onFileDropped($event) {
    let fileExtension = $event[0].name.split(".").pop();
    if (
      fileExtension == "csv" ||
      fileExtension == "xlsx" ||
      fileExtension == "xls"
    ) {
      this.prepareFilesList($event);
    } else {
      this._toastr.error("File Not Supported", "Error");
    }
  }
  prepareFilesList(file: any) {
    file.progress = 0;
    this.files = file;
    this.fileLength = file.length;
    this.uploadFilesSimulator();
  }
  addRequest() {
    this.switchTransactionLogArray.push(this.switchTransactionEntry());
  }
  deleteFile() {
    this.files = 0;
    this.fileLength = 0;
    this.isShowTable = false;
  }
  // formatStringToDate(input: string): string {
  //   const formattedDate = this.datePipe.transform(input, 'yyyy-MM-dd HH:mm:ss');
  //   return formattedDate || '';
  // }

  uploadFilesSimulator() {
    if (this.files.length <= 0) {
      return;
    } else {
      const progressInterval = setInterval(() => {
        if (this.files.progress === 100) {
          clearInterval(progressInterval);
          this.showInTable();
        } else {
          this.files.progress += 5;
        }
      }, 200);
    }
  }
  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return "0 Bytes";
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  export(): void {
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(this.data1);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "sheet1");

    XLSX.writeFile(wb, this.fileName);
  }
  data(data: any): XLSX.WorkBook {
    throw new Error("Method not implemented.");
  }

  showInTable() {
    this.switchTransactionLogArray.controls = [];
    this.dataFromExcel = [];
    // this.file = event.target.files[0];
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.files[0]);
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i)
        arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      //  first_sheet_name.trim();
      var worksheet = workbook.Sheets[first_sheet_name];

      //console.log(XLSX.utils.sheet_to_json(worksheet,{} ));

      var arraylist: any = XLSX.utils.sheet_to_json(worksheet, {
        raw: false,
        dateNF: "yyyy/mm/dd",
      });
      // this.headers = Object.keys(arraylist[0]);

      // const namesArray= new FormArray([], this.customGroupValidation);
      // const myForm = new FormGroup({
      //   inputName: new FormControl(""),
      //   names: this.namesArray
      // });

      for (let item of arraylist) {
        let dataForExcel = new AddSwitchTransactionLogCommand();
        dataForExcel.merchantId = item.MERCHANT_ID;
        dataForExcel.merchantName = item.MER_NAME;
        dataForExcel.transactionType = item.TRAN_TYPE;
        dataForExcel.responseCode = item.RESPOSE_CODE;
        dataForExcel.posEntryMode = item.POS_ENTRY_MOD;
        dataForExcel.responseLabel = item.RES_LABEL;
        dataForExcel.referenceNumber = item.REFERENCE_NUMBER;
        dataForExcel.currencyCode = item.CURR;
        dataForExcel.stanNumber = item.STAN_NUMBER;
        dataForExcel.terminalId = item.TERMINAL_ID;
        dataForExcel.transactionAmount = item.TRANSACTION_AMOUNT;
        dataForExcel.batchNumber = item.BATCH_NUMBER;
        dataForExcel.cardType = item.CARD_TYPE;
        dataForExcel.transactionDate = item.TRAN_DATE_TIME;
        dataForExcel.remarks = item.REMARKS;
        dataForExcel = Object.assign(dataForExcel, item);
        this.dataFromExcel.push(dataForExcel);
        this.switchTransactionLogArray.push(this.switchTransactionEntry());
        this.switchTransactionLogArray.patchValue(this.dataFromExcel);
      }
      const refArr = this.dataFromExcel.map((x) => x.referenceNumber);
      this.isShowTable = arraylist.length > 0 ? true : false;
      this.isShowGrid = this.dataFromExcel.length > 0 ? true : false;
      // let duplicatesArr = _.difference(this.dataFromExcel, _.uniqBy(this.dataFromExcel, 'referenceNumber'), 'referenceNumber');

      // if(duplicatesArr.length > 0){

      //   var listofDupIds : AddSwitchTransactionLogCommand[] = [];
      //     listofDupIds = Array.from(new Set(duplicatesArr));
      //     var uniqueDupRefNum = listofDupIds.map(x=>x.referenceNumber);
      //     var listOfDuplicateIds = uniqueDupRefNum.join(', ');
      //     this._toastr.error(`Duplicate Reference Number: ${listOfDuplicateIds} in Excel Sheet, Please Check !`, "Error");
      //     this.fileLength =0;
      //     return;
      //   }
    };
  }
  duplicateValueValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const values = control.value as any[];
      var arrayControl = control as FormArray;
      const duplicates: number[] = [];
      values.forEach((value, index) => {
        if (
          values.findIndex((v, i) => i !== index && v["referenceNumber"] === value["referenceNumber"]) !== -1 &&
          duplicates.indexOf(index) === -1
        ) {
          duplicates.push(index);
        }
      });

      // Set errors on duplicate elements
      if (duplicates.length > 0) {
        duplicates.forEach((index) => {
          arrayControl.controls[index].get('referenceNumber')?.setErrors({ "duplicateReferenceNo": true });
        });

      }
      return arrayControl;
    };
  }
  gridOptions = {
    rowSelection: "multiple",
    enableSorting: "true",
    enableColResize: "true",
    enableRtl: "true",
    pagination: true,
    cacheBlockSize: 10,
    paginationPageSize: 10,
    paginationAutoPageSize: "true",
    animateRows: "true",
    rowClicked: "true",
  };

  checkDuplicacy() {
    let length = this.switchTransactionLogArray.value.length;
    let controls = (<FormArray>this.switchTransactionLogArray).controls;
    for (let i = 0; i < length; i++) {
      for (let j = i + 1; j < length; j++) {
        if (
          controls[i].get("referenceNumber")?.value ==
          controls[j].get("referenceNumber")?.value
        ) {
          controls[i]
            .get("referenceNumber")
            ?.setErrors({ ["duplicateReferenceNo"]: true });
          controls[j]
            .get("referenceNumber")
            ?.setErrors({ ["duplicateReferenceNo"]: true });
        }
      }
    }
    this.switchTransactionLogArray.controls = controls;
    this.isShowGrid = this.dataFromExcel.length > 0 ? true : false;
  }
  onPrint(data) {
    console.log(data);
  }

  uploadExcelFile() {
    this.submitted = true;
    // Proceed with file upload if there are no errors
    if (!this.referenceNumberErrors.some(error => !!error)) {
      this.switchTransactionEntryData.addSwitchTransactionLogs = this.switchTransactionLogArray.value;
      const switchTransactionEntries = SwitchTransactionEntryCommand.fromJS(this.switchTransactionEntryData)
      this._transactionDashboardService
        .transactionDashboard_Post(switchTransactionEntries)
        .subscribe(
          (res) => {
            this._toastr.success("Excel File Upload Successfully", "Success");
            this.isShowTable = false;
          },
          (err) => {
            console.log(err.Response)
            if (err.status === 422) {
              const errorResponse = JSON.parse(err.response);
              const errors = errorResponse.errors;
              this._validationError.handleValidationErrorsArrayofThirdParty(this.switchTransactionLogArray, errors);
              this._toastr.error("Validation Error", "Error");
            }
            else {
              this._toastr.error("Cannot Upload Excel File !!", "Error");
              this.submitted = false;
            }
          }
        );
    }
  }
}
